import { useKnowledgeCrawlsTabStore } from './useKnowledgeCrawlsTabStore';
import { useKnowledgeDatabaseSharedStore } from './useKnowledgeDatabaseSharedStore';
import { useKnowledgeSettingsTabStore } from './useKnowledgeSettingsTabStore';

export function resetKnowledgeDatabaseDetailsStores() {
  useKnowledgeDatabaseSharedStore.getState().reset();
  useKnowledgeCrawlsTabStore.getState().reset();
  useKnowledgeSettingsTabStore.getState().reset();
}
